import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/SuitcaseTheatreArcadeStyle.css';

function Services() {
    return (
        <main className="services-page">
            <header className="services-hero fade-in">
                <p className="services-eyebrow">Bring miniature worlds to your community</p>
                <h1>Shows &amp; Arts Education</h1>
                <p className="services-intro">
                    Suitcase Theatre Arcade can be booked to present a miniature puppet show
                    or to lead an arts education activity shaped for your group and space.
                </p>
                <Link className="services-cta" to="/contact">
                    Ask about a booking
                </Link>
            </header>

            <section className="services-offerings" aria-labelledby="services-offerings-title">
                <h2 id="services-offerings-title">Ways to work with us</h2>
                <div className="services-card-grid">
                    <article className="service-card">
                        <span className="service-card-number" aria-hidden="true">01</span>
                        <h3>Puppet Show Presentations</h3>
                        <p>
                            Invite Suitcase Theatre Arcade to share portable, miniature puppet
                            shows with audiences at your event or venue.
                        </p>
                        <p className="service-card-label">A good fit for</p>
                        <ul>
                            <li>Festivals and community events</li>
                            <li>Libraries and schools</li>
                            <li>Retirement homes</li>
                            <li>Arts and cultural venues</li>
                        </ul>
                    </article>

                    <article className="service-card">
                        <span className="service-card-number" aria-hidden="true">02</span>
                        <h3>Arts Education Activities</h3>
                        <p>
                            Book a creative, participatory arts activity that draws on drama,
                            puppetry, storytelling and hands-on making.
                        </p>
                        <p className="service-card-label">Available for</p>
                        <ul>
                            <li>Schools and classrooms</li>
                            <li>Libraries</li>
                            <li>Before- and after-school programs</li>
                            <li>Community learning spaces</li>
                        </ul>
                    </article>

                    <article className="service-card">
                        <span className="service-card-number" aria-hidden="true">03</span>
                        <h3>Education Assistant &amp; Level 1 Support</h3>
                        <p>
                            Available to support Alberta classrooms, child-care programs and
                            learning spaces as an education assistant or Level 1 early childhood
                            educator.
                        </p>
                        <p className="service-card-label">Supported by</p>
                        <ul>
                            <li>Childhood Education certificate</li>
                            <li>Hands-on classroom and program experience</li>
                            <li>Drama-based, age-aware facilitation</li>
                        </ul>
                    </article>
                </div>
            </section>

            <section className="services-experience" aria-labelledby="services-experience-title">
                <div className="services-experience-heading">
                    <p className="services-eyebrow">Experience behind the work</p>
                    <h2 id="services-experience-title">Arts practice grounded in education</h2>
                </div>
                <div className="credential-list">
                    <div className="credential">
                        <strong>10 years</strong>
                        <span>of experience as an educational assistant and before- and after-school worker</span>
                    </div>
                    <div className="credential">
                        <strong>Childhood Education Certificate</strong>
                        <span>
                            supports work in Alberta as an education assistant or Level 1 early
                            childhood educator
                        </span>
                    </div>
                    <div className="credential">
                        <strong>Bachelor of Arts</strong>
                        <span>in Drama with a minor in Philosophy from the University of Alberta</span>
                    </div>
                    <div className="credential">
                        <strong>Active arts practice</strong>
                        <span>through regular participation in local and digital communities</span>
                    </div>
                </div>
            </section>

            <section className="services-footer-cta" aria-labelledby="services-booking-title">
                <div>
                    <p className="services-eyebrow">Plan something together</p>
                    <h2 id="services-booking-title">Tell us about your audience, venue and event.</h2>
                </div>
                <Link className="services-cta services-cta-light" to="/contact">
                    Start a conversation
                </Link>
            </section>
        </main>
    );
}

export default Services;
